import { computed, ref } from 'vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useGameStore from '@/store/modules/game.js';
import { useRoute } from 'vue-router';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';
import { gameThemeEnum } from '@/constants/game.js';

const usePreGameHook = () => {
  const appSettingsStore = useAppSettingsStore();
  const gameStore = useGameStore();

  const route = useRoute();

  const { redirectTo } = usePageNavigationHook();

  const isPreGameVisible = ref(false);
  const isGameThemeSelectCategory = computed(() => [gameThemeEnum.ALL, gameThemeEnum.SEASONAL].includes(appSettingsStore.appProperties.gameTheme));

  const setGameTypeAndStartPreGame = (gameType) => {
    gameStore.setGameType(gameType);

    isPreGameVisible.value = true;
  };

  const launchNewGameFlow = () => {
    if (isGameThemeSelectCategory.value) {
      redirectTo('SelectCategoryGame', { replace: route.name === 'MainGame' });
    } else {
      setGameTypeAndStartPreGame(gameThemeEnum.NO_CATEGORY);
    }
  };

  const hidePreGame = () => {
    isPreGameVisible.value = false;
  };

  return {
    isPreGameVisible,
    isGameThemeSelectCategory,
    launchNewGameFlow,
    setGameTypeAndStartPreGame,
    hidePreGame,
  };
};
export default usePreGameHook;
